import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ApiService } from '../../core/upgraded-providers';

@Component({
    selector: 'app-market-my-orders',
    templateUrl: './my-orders.component.pug',
    styleUrls: ['./my-orders.component.less']
})
export class MyOrdersComponent implements OnInit {

    public shards: any[] = [];

    constructor(
        private _route: ActivatedRoute,
        private _apiService: ApiService
    ) { }

    ngOnInit() {
        const data = this._route.snapshot.data['item'];
        if (data) {
            this.shards = data;
        } else {
            this.getData();
        }
    }

    onRefresh(next) {
        this.getData().then(() => next());
    }

    getData(): any {
        return this._apiService
            .get('game/market/my-orders', { })
            .then(({ list, shards }) => {
                if (shards) {
                    this.shards = Object.entries<any[]>(shards).map(([name, orders]) => ({
                        name,
                        orders
                    })).filter(({ orders }) => orders.length);
                }

                if (list) {
                    this.shards = [{
                        name: null,
                        orders: list
                    }];
                }
            });
    }

}
